module.exports = __webpack_public_path__ + "site/img/260.f5c89021.jpg";